import { useFind } from 'src/api/APIHooks';
import { useMemo } from 'react';

/**
 * Custom hook to fetch and transform contact method choices
 * @returns {Object} Contact method choices with value and display_name
 */
const useContactMethodChoices = () => {
  const contactMethodChoicesQuery = useFind(
    'contact_method_choices',
    {},
    {
      queryConfig: {
        placeholderData: undefined,
      },
      sort: 'value',
    },
  );

  const { data: contactMethodChoicesData, isLoading, isFetching } = contactMethodChoicesQuery;
  const rawContactMethodChoices = useMemo(
    () => contactMethodChoicesData?.data?.data ?? [],
    [contactMethodChoicesData],
  );

  // Transform to include display_name for consistent usage across components
  const contactMethodChoices = useMemo(
    () => rawContactMethodChoices.map((method) => ({
      value: method.value,
      display_name: method.description,
    })),
    [rawContactMethodChoices],
  );

  return {
    contactMethodChoices,
    isLoading,
    isFetching,
  };
};

export default useContactMethodChoices;
